import React from "react";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import { withRouter } from "react-router";

import axios from "../components/Axios";
import "./Login.css";

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    };
  }

  componentDidMount() {
    // settings of this browser outlive the session: the API url (dev), the remembered email ("Remember me"),
    // the language, the theme and the library view
    const keep = ["api_url", "remember", "i18nextLng", "theme", "view", "librarySort"];
    const kept = keep.map((k) => [k, localStorage.getItem(k)]);

    localStorage.clear();
    sessionStorage.clear();

    kept.forEach(([k, v]) => v !== null && localStorage.setItem(k, v));

    this.props.history.push("/login");
    /*
    axios.get('/auth/logout').then(function (response) {
        console.log(response.data);
        this.props.history.push("/");
      }.bind(this)).catch(function (error) {
          console.log(error); 
          this.setState({loading: false});
      }.bind(this));
    */
  }

  render() {
    return (
      <div className="background">
        <Container maxWidth="xs">
          <Paper className="formContainer">Login out...</Paper>
        </Container>
      </div>
    );
  }
}

export default withRouter(Index);
